enum AccountSignigClientConstants {
    FetchAccountSignigClientRequest = 'FETCH_OAUTH_CLIENTS_REQUEST',
    FetchAccountSignigClientSuccess = 'FETCH_OAUTH_CLIENTS_SUCCESS',
    FetchAccountSignigClientFailure = 'FETCH_OAUTH_CLIENTS_FAILURE',
    FetchAccountSignigClients = 'FETCH_ACCOUNT_SIGNING_CLIENTS'
  }
  
  export default AccountSignigClientConstants